import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
type CtaButtonProps = {
  label: string;
  id?: string;
  caption?: string;
  tone?: 'light' | 'dark';
};
export function CtaButton({
  label,
  id,
  caption,
  tone = 'light'
}: CtaButtonProps) {
  return <div className="flex w-full flex-col items-center" data-id="element-29" data-mp="ck9f3o7axsdd">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-2.5 rounded-2xl bg-gold px-4 py-[18px] text-center font-display text-[15px] font-black uppercase leading-tight tracking-tight text-navy-950 shadow-[0_6px_0_0_#b07d00] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-gold-light active:translate-y-1 active:shadow-[0_2px_0_0_#b07d00] focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-2 focus-visible:outline-electric sm:px-8 sm:py-5 sm:text-xl" data-id="element-30" data-mp="cmvo7s9ucfxp">
        <span data-id="element-31" data-mp="15bay60e48826">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:h-6 sm:w-6" strokeWidth={3} aria-hidden="true" data-id="element-32" data-mp="35x5xti7dww42" />
      </a>
      {caption && <p className={`mt-3 text-center text-sm font-medium ${tone === 'dark' ? 'text-white/75' : 'text-ink/60'}`} data-id="element-33" data-mp="3ewt1ybri0g0t">
          {caption}
        </p>}
    </div>;
}